import { Draft, PayloadAction } from '@apia/store';
import { TResponsiveTableSlice, TResponsiveTableState } from '../store/types';

export type TPayloadWithId<
  P = Record<string, unknown>,
  T extends string = string,
  M = never,
  E = never,
> = PayloadAction<P & { tableName: string }, T, M, E>;

export function getController2ReduxActions() {
  return {
    controller2UpdateSelectionState(
      state: Draft<TResponsiveTableSlice>,
      {
        payload: { tableName, ...payload },
      }: TPayloadWithId<Partial<TResponsiveTableState>>,
    ) {
      Object.assign(state[tableName], payload);
    },
  };
}
